import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { isStudentCell } from './tableConfig';
import { StudentDetailsTable } from './StudentDetailsTable';
import { useLocation } from 'react-router-dom';
var useTableRowActions = function (_a) {
    var cards = _a.cards;
    var search = useLocation().search;
    var studentId = new URLSearchParams(search).get('studentId');
    var _b = useState(Number(studentId)), selectedStudentId = _b[0], setSelectedStudentId = _b[1];
    var updateRow = React.useCallback(function (row) {
        if (!selectedStudentId)
            return undefined;
        if (isStudentCell(row.original) &&
            row.original.id === selectedStudentId) {
            var timeout_1 = setTimeout(function () {
                row.toggleRowExpanded(true);
            }, 0);
            return function () { return clearTimeout(timeout_1); };
        }
        return undefined;
    }, [selectedStudentId]);
    var renderSubRow = React.useCallback(function (row, refElement) {
        if (!isStudentCell(row.original))
            return null;
        var handleDetailsLoad = function () {
            if (!selectedStudentId || row.original.id !== selectedStudentId)
                return;
            window.scrollTo({
                top: refElement.getBoundingClientRect().y + window.scrollY,
                behavior: 'smooth',
            });
            setSelectedStudentId(0);
        };
        return (_jsx(StudentDetailsTable, { student: row.original, cards: cards, onLoad: handleDetailsLoad }, void 0));
    }, [selectedStudentId, cards]);
    return {
        updateRow: updateRow,
        renderSubRow: renderSubRow,
    };
};
export { useTableRowActions };
